import React, {useEffect, useState, ReactNode, FC} from "react";
import {Grid, Typography} from "@mui/material";
import DateTimePicker from "../../deprecatedUikit/DateTimePicker/DateTimePicker";
import type {GroupedLocationInventoryActivity} from "../../../types/GroupedLocationInventoryActivity";
import moment from "moment-timezone";

interface IDateCorrectionForm {
  inventory: GroupedLocationInventoryActivity;
  correctActivityDate?: moment.Moment | null;
  setCorrectActivityDate?: (date: moment.Moment | null) => void;
  onDateTimeError?: (error: string | null, value?: string) => void;
  // Optional prop that disables the date picker from selecting dates before the inventory's checkin date
  disableDatesBeforeCheckIn?: boolean;
  // Additional form elements that should be wrapped in Grid items
  children?: ReactNode;
  currentTimeData: { dateTime: moment.Moment; timeZoneName: string; timeZoneAbbreviation: string };
}

const DateCorrectionForm: FC<IDateCorrectionForm> = ({
                                                       inventory,
                                                       correctActivityDate,
                                                       setCorrectActivityDate,
                                                       onDateTimeError = () => {
                                                       },
                                                       disableDatesBeforeCheckIn = false,
                                                       currentTimeData,
                                                       children
                                                     }) => {

  const {timeZoneName} = inventory;

  const [dateErrorMessage, setDateErrorMessage] = useState("");

  useEffect(() => {
    if (correctActivityDate && correctActivityDate.isAfter(currentTimeData.dateTime)) {
      setDateErrorMessage(`Please select an activity time before ${currentTimeData.dateTime.format("hh:mm A MM/DD/YY")} ${currentTimeData.timeZoneAbbreviation}.`);
      onDateTimeError("error");
    } else {
      setDateErrorMessage("");
      onDateTimeError(null);
    }
  }, [correctActivityDate, currentTimeData, onDateTimeError]);

  return <Grid item container direction="column" spacing={2}>
    <Grid item marginTop="1em">
      <DateTimePicker
        value={correctActivityDate ? correctActivityDate.toISOString() : null}
        label="Check Out Date and Time"
        onChange={(date) => setCorrectActivityDate?.(date ? moment(date) : null)}
        minDateTime={disableDatesBeforeCheckIn && inventory.checkinDate ? inventory.checkinDate : undefined}
        timezone={timeZoneName}
        maxDateTime={currentTimeData.dateTime.toISOString()}
      />
    </Grid>
    {
      dateErrorMessage ?
        <Grid item alignSelf={'center'}>
          <Typography variant="subtitle1" color="tomato" fontSize="0.9em">{dateErrorMessage}</Typography>
        </Grid>
        : ""
    }
    {children}
  </Grid>
}

export default DateCorrectionForm;
